module.exports = __webpack_public_path__ + "img/bg.9e48c3ba.png";